import { render } from "./EditSettingsProfile.vue?vue&type=template&id=aed1d8fa&scoped=true&ts=true"
import script from "./EditSettingsProfile.vue?vue&type=script&lang=ts"
export * from "./EditSettingsProfile.vue?vue&type=script&lang=ts"

import "./EditSettingsProfile.vue?vue&type=style&index=0&id=aed1d8fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aed1d8fa"]])

export default __exports__